import React from "react";
import { Link } from "react-router-dom";

export const Logo = ({ light = false, className = "" }) => {
  return (
    <Link to="/" data-testid="logo-link" className={`flex items-center gap-3 ${className}`}>
      <img
        src="/valuelix-icon-192.png"
        alt=""
        style={{ height: "52px", width: "52px" }}
        className="shrink-0 rounded-full object-cover shadow-sm ring-1 ring-slate-200"
      />
      <span
        style={{ fontSize: "22px" }}
        className={`font-display font-extrabold leading-none tracking-tight ${light ? "text-white" : "text-brand-navy"}`}
      >
        Valuelix
      </span>
    </Link>
  );
};
